import { combineReducers } from '@reduxjs/toolkit';
import loading, { loadingInitialState } from './slicers/loading.slice';
import apiMessage, { apiMessageInitialState } from './slicers/api-message.slice';
import auth, { authInitialState } from './slicers/auth.slice';
import platform, { platformInitialState } from '@/redux/slicers/platform.slice';
import store, { storeInitialState } from '@/redux/slicers/store.slice';
import breadcrumb, { breadcrumbInitialState } from '@/redux/slicers/breadcrumb.slice';
import roles, { rolesInitialState } from '@/redux/slicers/roles.slice';
import order, { orderInitialState } from './slicers/order.slice';
import department, { departmentInitialState } from '@/redux/slicers/department.slice';
import user, { userInitialState } from '@/redux/slicers/user.slice';
import manageRole, { manageRoleInitialState } from '@/redux/slicers/manage-role.slice';

export type RawRootState = typeof rootState;
export const allInitialStates = {
  loadingInitialState,
  apiMessageInitialState,
  authInitialState,
  platformInitialState,
  storeInitialState,
  breadcrumbInitialState,
  rolesInitialState,
  orderInitialState,
  departmentInitialState,
  userInitialState,
  manageRoleInitialState,
};
const rootState = {
  loading,
  apiMessage,
  auth,
  platform,
  store,
  breadcrumb,
  roles,
  order,
  department,
  user,
  manageRole,
};

const rootReducer = combineReducers(rootState);
export const rootReducers = rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
